import { useParams } from "react-router-dom";

export default function Cs() {
  const { type } = useParams();
  let content;

  switch (type) {
    case 'mail':
      content =
        <>

          <div className="top__banner top5">
            <div className="tb__text">
              <h1>고객센터</h1>
              <h2>CUSTOMER SERVICE CENTER</h2>
            </div>
          </div>

          <div className="nav__wrap">
            <div className="nav__container">
              <div className="nav">
                <div className="mnav">
                  <div className="depth depth1">
                    <span className="">고객센터</span>
                  </div>
                  <div className="depth depth2">
                    <span className="">대표메일</span>
                    <div className="snav">
                      <ul>
                        <li className="on"><a href="mail"><span>대표메일</span></a></li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="loc">
                  <img src="../img/ico/home_icon.png" alt="home" onClick={() => (window.location.href = '/')} className="menuPathBtn" />
                  <span className="arrow"></span>
                  <span className="menuPathBtn" onClick={() => (window.location.href = 'mail')}>고객센터</span>
                  <span className="arrow"></span>
                  <span>대표메일</span>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div className="container-1400">
              <div className="contents">
                <div className="content">

                  <div className="">
                    <div className="board_top">
                      대표메일
                    </div>
                  </div>

                  <div className="email">
                    <p><a href="mailto:aspec@a-spec.co.kr">aspec@a-spec.co.kr</a></p>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </>;

      break;
    default:
      content = <h1>404 Not Found</h1>;
  }

  return (
    <>
      {content}
    </>
  );
}